export const PrivacyPolicyAndTermsAndConditionsLink =
    'https://acm.account.sony.com/tos_pp?client_id=74cceb89-9ff7-47f8-bc74-6bab2b129a30&country_code=US&lang=en-US#page-top';
